import { render, staticRenderFns } from "./ProgrammeAndPassport.vue?vue&type=template&id=33ffa814"
import script from "./ProgrammeAndPassport.vue?vue&type=script&lang=js"
export * from "./ProgrammeAndPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports